import { Divider, Grid, Stack, Typography } from '@vapor/material'
import { useMemo } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { FiscalType } from 'src/api/api.generated'
import useFormatDate from 'src/app/hooks/current-locale/use-format-date'

type CoCreditNoteHeaderProps = {
  numberExtended: string
  documentDate: Date
  fiscalType: FiscalType
}

export default function CoCreditNoteHeader({ numberExtended, documentDate, fiscalType }: CoCreditNoteHeaderProps) {
  const formatDate = useFormatDate()
  const { t } = useTranslation()

  const fiscalTypeString = useMemo(() => {
    switch (fiscalType) {
      case FiscalType.NON_FISCAL:
        return (
          <Trans
            i18nKey="pms.common.checkout_document.amounts.non_fiscal_value"
            values={{
              documentNumber: numberExtended,
              documentDate: formatDate(documentDate),
            }}
          />
        )
      case FiscalType.RECEIPT:
        return (
          <Trans
            i18nKey="pms.common.checkout_document.amounts.receipt_value"
            values={{
              documentNumber: numberExtended,
              documentDate: formatDate(documentDate),
            }}
          />
        )
      case FiscalType.RETURN_DEPOSIT:
        return (
          <Trans
            i18nKey="pms.common.checkout_document.amounts.return_deposits_value"
            values={{
              documentNumber: numberExtended,
              documentDate: formatDate(documentDate),
            }}
          />
        )
      default:
        return (
          <Trans
            i18nKey="pms.common.checkout_document.amounts.credit_note_value"
            values={{
              documentNumber: numberExtended,
              documentDate: formatDate(documentDate),
            }}
          />
        )
    }
  }, [fiscalType])

  return (
    <Grid item xs={12}>
      <Stack direction="column" spacing={1} mb={1}>
        <Typography variant="body">
          <b>{t('pms.common.checkout_document.amounts.credit_note_title')}</b>
        </Typography>
        <Typography variant="body">{fiscalTypeString}</Typography>
      </Stack>
      <Divider light />
    </Grid>
  )
}
